<template>
  <div class="mesh-bg" aria-hidden="true"></div>
  <ErrorBoundary>
    <RouterView v-slot="{ Component, route }">
      <Transition name="page" mode="out-in">
        <!--
          Key by top-level segment only (e.g. /admin, /login, /inbox) so that
          navigating between sibling admin sub-routes keeps AdminLayout mounted
          and avoids the visual "full page reload" effect.
        -->
        <component :is="Component" :key="route.path.split('/')[1] || 'root'" />
      </Transition>
    </RouterView>
  </ErrorBoundary>
  <Toaster
    position="top-right"
    :theme="'dark'"
    :rich-colors="true"
    :close-button="true"
    :duration="4000"
  />
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router';
import ErrorBoundary from '@/components/ui/ErrorBoundary.vue';
</script>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 280ms cubic-bezier(0.16, 1, 0.3, 1);
}
.page-enter-from {
  opacity: 0;
  transform: translateY(8px);
}
.page-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>